import gql from 'graphql-tag';

import { courseCategoryFragment } from '~/shared/graphql-queries/course-categories/index';

export default gql`
  mutation updateByIdCourseCategoryMutation(
    $_id: MongoID!
    $record: UpdateByIdCourseCategoryInput!
  ) {
    updateByIdCourseCategoryMutation(_id: $_id, record: $record) {
      recordId
      record {
        ...CourseCategoryFragment
      }
      message
      title
    }
  }
  ${courseCategoryFragment}
`;
